import { Component, OnDestroy, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { DialogComponent, DialogService } from 'ngx-bootstrap-modal';
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router";
import { CommonConst } from '../shared/const/common-const';
import { MessageUtil } from '../shared/utility/message-util';
import { N201A04OutShohinrisutoData } from '../shared/webapi-data/n201a04-out-shohinrisuto-data';
import { N2013OutputData } from './n2013-output-data';
import { N2013InputData } from './n2013-input-data';
import { RedirectUtil } from '../shared/utility/redirect-util';
import { CommonStorageKey } from '../shared';
declare var $: any;

export interface DialogModel {
  item: any;
  name: any;
  otodokesakukubun: any;
  okurisaki: any;
  yubimbango: any;
  kenkodo: any;
  jusho: any;
  shohinkubun: any;
  elementId: any;
}

@Component({
  selector: 'app-n2014',
  templateUrl: './n2014.component.html',
  styleUrls: ['./n2014.component.css']
})
export class N2014Component extends DialogComponent<DialogModel, boolean> implements DialogModel, OnInit, OnDestroy {
  @ViewChild('cancelEr') cancelEr: ElementRef;

  item: any;
  name: any;
  otodokesakukubun: any;
  okurisaki: any;
  yubimbango: any;
  kenkodo: any;
  jusho: any;
  shohinkubun: any;
  elementId: any;

  // 一覧
  public inputData = new N2013InputData();
  public outputData = new N2013OutputData();
  public detailData: N201A04OutShohinrisutoData[] = [];
  // 重クリック防止
  public isLoading: boolean;

  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router) {
    super(dialogService);
  }

  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245

    this.inputData.himban = this.item;
    this.inputData.otodokesakikubun = this.otodokesakukubun;
    this.inputData.okurisaki = this.okurisaki;
    this.inputData.yubimbango = this.yubimbango;
    this.inputData.todofuken = this.kenkodo;
    this.inputData.jusho = this.jusho;
    this.inputData.syouhinnKbn = this.shohinkubun;

    document.body.style.cursor = 'wait';
    this.inputData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N2013OutputData>('/InitialN2014', this.inputData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        this.close();
        return;
      }

      this.outputData = result[0];
      if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        let tempDetailData = this.outputData.apiOutData.shohinrisuto;
        this.detailData = [];
        for (let i = 0; i < tempDetailData.length; i++) {
          if (tempDetailData[i].suryo !== 0) {
            this.detailData.push(tempDetailData[i]);
          }
        }

      } else if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_NG) {
        this.messageInfo.setMsg(MessageUtil.getStorageMessage(this.outputData.messageId));
      } else if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_API_NG3 || this.outputData.rtnCode == CommonConst.C_RTN_CODE_API_NG4) {
        this.messageInfo.setMsg(this.outputData.apiOutData.messejihombun);
      } else {
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      }
    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; });
  }

  cancel() {
    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  ngOnDestroy() {
    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーおよび十字キーの場合
    if (event.keyCode == 9 || event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
      this.cancelEr.nativeElement.focus();
      return false;
    }
    // Enterキーの場合
    if (event.keyCode == 13) {
      this.cancel();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/n201/n2014.component.ts